var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 42.0002,
    height: 42.0002,
    rx: 21.0001,
    fill: "#F9CF66"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8187 17.6804V14.8168L27.6824 11.9531L28.6369 13.8622L30.546 14.8168L27.6824 17.6804H24.8187ZM24.8187 17.6804L21.0005 21.4986M30.5461 21.4986C30.5461 26.7704 26.2724 31.0441 21.0006 31.0441C15.7287 31.0441 11.4551 26.7704 11.4551 21.4986C11.4551 16.2268 15.7287 11.9531 21.0006 11.9531M25.7733 21.4986C25.7733 24.1345 23.6365 26.2714 21.0006 26.2714C18.3647 26.2714 16.2278 24.1345 16.2278 21.4986C16.2278 18.8627 18.3647 16.7259 21.0006 16.7259",
    stroke: "#FFFBE5",
    strokeWidth: 2.29092,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.ec676745081d06f5c5bd5b041eda89ea.svg";
export { ForwardRef as ReactComponent };